module.exports = __webpack_public_path__ + "static/media/404.66efd38a.svg";